import { render, staticRenderFns } from "./StepsInfo.vue?vue&type=template&id=74104964"
import script from "./StepsInfo.vue?vue&type=script&lang=js"
export * from "./StepsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports